import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const SalesChart = ({ data }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return `${date?.getMonth() + 1}/${date?.getDate()}`;
  };

  const formatCurrency = (value) => {
    return `$${value?.toFixed(2)}`;
  };

  if (!data || data?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Revenue Trends</h2>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="TrendingUp" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No sales data available for the selected period</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Revenue Trends</h2>
        <div className="flex items-center gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-primary"></div>
            <span className="text-muted-foreground">Revenue</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-secondary"></div>
            <span className="text-muted-foreground">Transactions</span>
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis
            dataKey="date"
            tickFormatter={formatDate}
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            yAxisId="left"
            tickFormatter={formatCurrency}
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            formatter={(value, name) => {
              if (name === 'revenue') return [formatCurrency(value), 'Revenue'];
              return [value, 'Transactions'];
            }}
            labelFormatter={(label) => `Date: ${label}`}
            contentStyle={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '8px',
              color: 'var(--color-foreground)'
            }}
          />
          <Legend />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="revenue"
            stroke="var(--color-primary)"
            strokeWidth={2}
            dot={{ fill: 'var(--color-primary)', r: 4 }}
            activeDot={{ r: 6 }}
            name="Revenue"
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="transactions"
            stroke="var(--color-secondary)"
            strokeWidth={2}
            dot={{ fill: 'var(--color-secondary)', r: 4 }}
            activeDot={{ r: 6 }}
            name="Transactions"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesChart;